const widgetForm = {
    /**
     * Company form key
     * @type {String}
     */
    key: "widgetForm",

    /**
     * Company form fields object
     * @type {Object}
     */
    fields: {
        logo: null,
        backgroundColor: "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)",
        status: "Hej! 👋🏻",
        message: "Vad vill du ha hjälp med?",
        showReviews: true,
    },

    /**
     * Company form errors object
     * @type {Object}
     */
    errors: {},

    /**
     * Company form mode
     * @type {String}
     */
    mode: "create",

    /**
     * Company form path
     * @type {String}
     */
    path: "/api/b2b/company/widget-settings",

    /**
     * Company form helpers
     * @type {Object}
     */
    helpers: {},
};

export default widgetForm;
